import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
	useEffect(() => {
		const prefersReduced =
			typeof window !== "undefined" &&
			window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
		// Disable smooth scroll for automated browsers (Playwright/QA) so
		// scroll-to-y works predictably during tests.
		const isAutomation =
			typeof navigator !== "undefined" && navigator.webdriver === true;
		if (prefersReduced || isAutomation) return;

		const lenis = new Lenis({
			duration: 1.35,
			lerp: 0.08,
			smoothWheel: true,
			wheelMultiplier: 1,
			touchMultiplier: 1.4,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		});

		let rafId;
		const raf = (time) => {
			lenis.raf(time);
			rafId = requestAnimationFrame(raf);
		};
		rafId = requestAnimationFrame(raf);
		if (typeof window !== "undefined") window.__lenis = lenis;

		return () => {
			cancelAnimationFrame(rafId);
			lenis.destroy();
			if (typeof window !== "undefined" && window.__lenis === lenis) {
				delete window.__lenis;
			}
		};
	}, []);
	return children;
}
